import getLogger from "../logger/index";
import { useEffect } from 'react';
const cwvLogger = getLogger("cwv-tracker");
import {
  onINP,
  onFID,
  onCLS,
  onLCP,
  onTTFB,
  onFCP,
} from 'web-vitals/attribution';

export const elementTracking = ({ name, value, attribution }) => {
  try {
    if (typeof window !== "undefined" && window.newrelic) {
      name = name?.toLowerCase();
      const cwvObj = {};
      let eventObj = {};
      switch (name) {
        case "cls":
          cwvObj[`rdc-web-vitals-element`] = attribution?.largestShiftTarget;
          eventObj = attribution?.largestShiftEntry;
          break;
        case "lcp":
          cwvObj[`rdc-web-vitals-element`] = attribution?.element;
          eventObj = attribution?.lcpEntry;
          break;
        case "fcp":
          cwvObj[`rdc-web-vitals-element`] = attribution?.element;
          eventObj = attribution?.fcpEntry;
          break;
        case "ttfb":
          cwvObj[`rdc-web-vitals-element`] = attribution?.element;
          eventObj = attribution?.navigationEntry;
          break;
        case "fid":
        case "inp":
          cwvObj[`rdc-web-vitals-element`] = attribution?.eventTarget;
          eventObj = attribution?.eventEntry;
          break;
      }

      cwvObj[`rdc-web-vitals-${name}`] = value;
      cwvObj[`rdc-web-vitals-obj`] = JSON.stringify(eventObj);
      window.newrelic.addPageAction(`rdc-web-vitals-${name}`, cwvObj);
    }
  } catch (e) {
    cwvLogger.error(`Can not report RUM ${name} data due to`, e);
  }
};

export const useTrackCWV = () => {
  useEffect(() => {
    onFID(elementTracking);
    onINP(elementTracking);
    onCLS(elementTracking);
    onLCP(elementTracking);
    onTTFB(elementTracking);
    onFCP(elementTracking);

    return () => {
      // Clean up the listener when the component is unmounted
      onFID(null);
      onINP(null);
      onCLS(null);
      onLCP(null);
      onTTFB(null);
      onFCP(null);
    };
  }, []);
};
